import React, { useState, useRef, useEffect } from 'react';
import { ReactTabulator } from 'react-tabulator';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap'; // 추가된 부분
import API from '../../api/api.jsx';
import CustomToast from '../../components/toast/toast.jsx';

// 결재선등록 모달
const Sanc_003_01 = ({ showModal, setShowModal, UserData, handleQuery }) => {

    // 다국어
    const { t,i18n }     = useTranslation();

    // 결재선명
    const [name, setName] = useState('');

    // Tabulator에 접근하기 위한 참조 설정
    const tableRef1 = useRef(null);
    const tableRef2 = useRef(null);

    // 좌측 Tabulator에 들어갈 전체 직원 목록
    const [staffListData, setStaffListData]         = useState(UserData);

    // 우측 Tabulator에 들어갈 결재선에 등록될 직원 목록
    const [approvalStaffData, setApprovalStaffData] = useState([]);

    // 토스트
	const [toast, setToast] = useState(false);
	const [text, setText]   = useState('');

    // 모달을 닫는 행위가 발생하면 기존에 작업 중이던 데이터들을 초기화
    const handleClose = () => {
		setStaffListData(UserData);
        setName('');
        setApprovalStaffData([]);
        setShowModal(false);
	};

    // 결재선명 변경
    const handleChangeName = (e) => {
        setName(e.target.value);
    };

    // 오른쪽 화살표 버튼 액션 (좌측 -> 우측 으로 직원 목록 전달)
    const handleRightArrowClick = () => {
        // 좌측 Tabulator에서 선택한 Data에 접근
        const selectedRows = tableRef1.current.getSelectedData();
        
        // user_seq를 바탕으로 해당 row를 지우는 부분
        setStaffListData((prevData) => {
            const selectedRowIds = selectedRows.map((row) => row.user_seq);
            const updatedData    = prevData.filter((row) => !selectedRowIds.includes(row.user_seq));

            // 지우면 바로 변화가 적용되게
            if (tableRef1.current) {
                tableRef1.current.replaceData(updatedData);
            }

            return updatedData;
        });
    
        // 우측 Tabulator에 옮겨진 데이터가 표시되게 하는 부분
        setApprovalStaffData((prevData) => [...prevData, ...selectedRows]);
    };

    // 왼쪽 화살표 버튼 액션 (좌측 <- 우측 으로 직원 목록 전달)
    const handleLeftArrowClick = () => {
        // 우측 Tabulator에서 선택한 Data에 접근
        const selectedRows = tableRef2.current.getSelectedData();
        
        // user_seq를 바탕으로 해당 row를 지우는 부분
        setApprovalStaffData((prevData) => {
            const selectedRowIds = selectedRows.map((row) => row.user_seq);
            const updatedData    = prevData.filter((row) => !selectedRowIds.includes(row.user_seq));

            // 지우면 바로 변화가 적용되게
            if (tableRef2.current) {
                tableRef2.current.replaceData(updatedData);
            }

            return updatedData;
        });
    
        // 좌측 Tabulator에 옮겨진 데이터가 표시되게 하는 부분
        setStaffListData((prevData) => [...prevData, ...selectedRows]);
    };

    // 결재선을 저장하는 액션
    const handleSave = async (e) => {

        const saveData = tableRef2.current.getData();

        if (!name) {
            alert("결재선명을 입력해주세요.");
            return;
        };

        if (saveData.length === 0) {
            alert("결재를 진행할 직원 명단을 선택해주세요.");
            return;
        };

        try {
                const data = await API.fetchSanc003ApprovalSave(name, saveData);

                setText(t(`APPROVAL.${data.message}`, { defaultValue : data.message }));

                setToast(true);

                setShowModal(false);

                handleQuery();

        } catch (error) {
            alert("결재선등록 오류가 발생했습니다. 관리자에게 문의하세요.");
            return; 
        }
    };

   // Tabulator columns 목록
	const titleColunms1 = (t) => {
		return [
            {formatter:"rowSelection", titleFormatter:"rowSelection", headerHozAlign: 'center', hozAlign:"center", headerSort:false, width:30, cellClick:function(e, cell){
                cell.getRow().toggleSelect();
            }},	
            { title: t('STAFF_MANAGEMENT.성명', { defaultValue: '성명' }), field: 'name', headerHozAlign: 'center', hozAlign: 'center', width:120 },
            { title: '아이디', field: 'user_id', headerHozAlign: 'center', hozAlign: 'center', width:200,visible:false },
            { title: t('STAFF_MANAGEMENT.권한', { defaultValue: '권한' }), field: 'authority', headerHozAlign: 'center', hozAlign: 'center', width:200,visible:true },
            { title: 'SEQ', field: 'use_seq', headerHozAlign: 'center', hozAlign: 'center', width:200 ,visible: false},
        ];
    }

	// Tabulator columns 목록
	const titleColunms2 = (t) => {
		return [
            {rowHandle:true, formatter:"handle", headerSort:false, frozen:true, width:30, minWidth:30},
            { title:  t('STAFF_MANAGEMENT.성명', { defaultValue: '성명' }), field: 'name', headerHozAlign: 'center', hozAlign: 'center', width:120 },
            { title: '아이디', field: 'user_id', headerHozAlign: 'center', hozAlign: 'center', width:200,visible:false },
            { title: t('STAFF_MANAGEMENT.권한', { defaultValue: '권한' }), field: 'authority', headerHozAlign: 'center', hozAlign: 'center', width:200,visible:true },
            { title: 'SEQ', field: 'use_seq', headerHozAlign: 'center', hozAlign: 'center', width:200 ,visible: false},
        ];
    }

    const [columns1, setColumns1]                 = useState(titleColunms1(t));
    const [columns2, setColumns2]                 = useState(titleColunms2(t));

    // 화면 접근 시 마다 초기에 전달 받은 전체 직원 목록을 좌측 Tabulator에 Display
    useEffect(() => {
        // UserData 배열의 authority 번역
        const translatedData = UserData.map(item => ({
            ...item,
            authority: t(`AUTHORITY.${item.authority}`),
        }));

        // 번역된 데이터로 state 업데이트
        setStaffListData(translatedData);
        
        setColumns1(titleColunms1(t))
        setColumns2(titleColunms2(t))

        setApprovalStaffData([]);
    }, [i18n.language, t,UserData]);

    return (
        <>
            <CustomToast show={toast} setToast={setToast} text={text} />
            <Modal show={showModal} onHide={handleClose} centered dialogClassName="modal-lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{t('APPROVAL.결재선명', { defaultValue: '결재선명' })}</Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-start">
                    <div className='row ms-0 mb-2'>
                        <div className='col-md-2 bg-light d-flex align-items-center pt-2 pb-2'>{t(`APPROVAL.결재선명`, { defaultValue: '결재선명' })} <span className="text-danger">*</span></div>
                        <div className='col-md-10 pt-2 pb-2'>
                            <input type='text' className='form-control' value={name} onChange={handleChangeName}></input>
                        </div>
                    </div>

                    <div className="row gx-4">
                        <div className="col-lg-12">
                            <div className="card border-1 mb-4">
                                {/* 폼시작  2023.11.30 추가 전종표 */}
                                {/* ref={formRef}를 사용하여 formRef가 form 엘리먼트를 참조하도록 설정. 
                                그리고 handleSave 함수에서는 이 formRef를 사용하여 submit 메소드를 호출 */}
                                <div className="card-body fw-bold ps-0 pe-0">
                                    <div className="row">
                                        <div className="col-lg-5">
                                            <div className="form-group mb-0">
                                                <ReactTabulator
                                                    onRef={(r) => (tableRef1.current = r.current)}
                                                    columns={columns1}
                                                    data={staffListData}
                                                    id="user_grid"
                                                    options={{
                                                        layout: "fitDataStretch",
                                                        height: "540px",
                                                        rowFormatter: function (row) {
                                                            row.getElement().style.fontSize = "14px";
                                                        },
                                                    }}
                                                    className="responsive-tabulator"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-2 d-flex flex-column justify-content-center">
                                            <button className='border-0 bg-transparent fs-30px hover-effect' onClick={handleRightArrowClick}>
                                                <i class="fa-solid fa-right-long"></i>
                                            </button>
                                            <button className='border-0 bg-transparent fs-30px hover-effect' onClick={handleLeftArrowClick}>
                                                <i class="fa-solid fa-left-long"></i>
                                            </button>
                                        </div>

                                        <div className="col-lg-5">
                                            <ReactTabulator
                                                onRef={(r) => (tableRef2.current = r.current)}
                                                columns={columns2}
                                                data={approvalStaffData}
                                                id="approval_grid"
                                                selectable="true"
                                                options={{
                                                    layout: "fitDataStretch",
                                                    height: "540px",
                                                    movableRows: true,
                                                    rowFormatter: function (row) {
                                                        row.getElement().style.fontSize = "14px";
                                                    },
                                                }}
                                                className="responsive-tabulator"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="d-block">
                    <button className="btn btn-outline-gray me-1 mb-1 w-auto" onClick={handleClose}>
                        <i className="fa fa-backward"></i> {t('COMMON.이전', { defaultValue: '이전' })}
                    </button>

                    <button className="btn btn-outline-success float-end mt-1 mb-1 me-1 ms-auto w-100px" onClick={handleSave}>
                        {t('COMMON.저장', { defaultValue: '저장' })} <i className="fa fa-sign-in"></i>
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Sanc_003_01;